// Components
import SearchFilterIcon from "components/atoms/SearchFilterIcon/SearchFilterIcon";

// Type definitions
import type { ReimbSummaryDataType } from "redux/types";

// Constants
import { MONTHLY_DECLARATIONS as Constants } from "constants/global";

// Hooks
import { useCustomSearchFilterIcon } from "containers/MonthlyDeclaration/MonthlyDeclarationCustomFilter/useCustomSearchFilterIcon";

export type MDCustomSearchFilterIconProps = {
	infoItem: ReimbSummaryDataType;
};

const MDCustomSearchFilterIcon = ({ infoItem }: MDCustomSearchFilterIconProps): JSX.Element => {
	const { groupCode, handleToggleFilter } = useCustomSearchFilterIcon({ infoItem });

	return (
		<SearchFilterIcon
			defaultSelectedFilter={Constants.DEFAULT_STATUS}
			defaultSelectedFilterValues={[Constants.DEFAULT_STATUS[0].value, Constants.DEFAULT_STATUS[1].value]}
			label="Filter"
			groupCode={groupCode}
			onClick={() => handleToggleFilter(groupCode)}
		/>
	);
};

export default MDCustomSearchFilterIcon;
